import { MinzeElement } from "minze";

export interface TjShineIcon {}

export class TjShineIcon extends MinzeElement {
  html = () => `
    <svg width="49" height="50" viewBox="0 0 49 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.3193 6.02563L22.2774 17.0651" stroke="#F0B9D8" stroke-width="4" stroke-linecap="round"/>
      <path d="M43.8145 20.1671L32.775 23.1251" stroke="#F0B9D8" stroke-width="4" stroke-linecap="round"/>
      <path d="M26.7139 33.623L29.6719 44.6625" stroke="#F0B9D8" stroke-width="4" stroke-linecap="round"/>
      <path d="M16.2158 27.5627L5.17633 30.5208" stroke="#F0B9D8" stroke-width="4" stroke-linecap="round"/>
    </svg>
  `;

  css = () => `
    
  `;
}
